// extracted by mini-css-extract-plugin
export default {"attachmentBox":"AttachmentView_attachmentBox__kyVkG","buttons":"AttachmentView_buttons__ryn8G"};